import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  max-height: 78vh;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Content = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  // margin-top: 20px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: block;
  // max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
`;

export const TableHeader = styled.thead`
  background: #914046;
  color: white;
  display: table;
  width: 100%;
  table-layout: fixed;
`;

export const TableRow = styled.tr`
  display: table;
  width: 100%;
  table-layout: fixed;

  &:nth-child(even) {
    background: #f8f9fa;
  }

  &:hover {
    background: #e9ecef;
  }
`;

export const TableBody = styled.tbody`
  display: block;
  // max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const TableCell = styled.td`
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;

  ${props =>
    props.header &&
    `
    font-weight: bold;
    background: #914046;
    color: white;
  `}
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background: #e9ecef;
  }

  svg {
    width: 16px;
    height: 16px;
    fill: #914046;
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;

  h2 {
    margin: 0 0 20px 0;
    color: #914046;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-weight: bold;
  color: #333;
`;

export const Input = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #914046;
    box-shadow: 0 0 0 2px rgba(145, 64, 70, 0.2);
  }

  &[type="password"] {
    font-family: monospace;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s;
  }

  button[data-variant="cancel"] {
    background: #6c757d;
    color: white;

    &:hover {
      background: #5a6268;
    }
  }

  button[data-variant="primary"],
  button[type="submit"]:not([data-variant]) {
    background: #914046;
    color: white;

    &:hover {
      background: #7a363b;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }

  button[data-variant="danger"] {
    background: #dc3545;
    color: white;
    margin-right: auto;

    &:hover {
      background: #c82333;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;

export const DangerActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: #dc3545;
  font-size: 12px;
  font-weight: bold;

  &:hover {
    background: #f8d7da;
  }
`;

export const AddButton = styled.button`
  align-self: flex-start;
  padding: 10px 18px;
  border: none;
  border-radius: 4px;
  background: #914046;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #7a363b;
  }
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: normal;
  color: #333;
  cursor: pointer;

  input {
    width: 16px;
    height: 16px;
  }
`;

export const HelperText = styled.small`
  color: #666;
  margin-top: 4px;
`;
